<div class="form">
  <div class="form__title">{{'t.sure-cancel-bonus' | translate }}</div>
  <div class="form__description">{{'t.popup-bonus-cancel-desc' | translate}}</div>

  <div class="submit-container">
    <button class="btn btn--filled-secondary" (click)="modal.close()">{{ 't.continue-playing' | translate }}</button>
    <button class="btn btn--filled-primary" (click)="modal.close(true)">{{ 't.cancel-bonus' | translate }}</button>
  </div>
</div>
